export interface IProps {
    /** Tailwind sizing for the block, e.g. 'h-8 w-24'. */
    className?: string;
}

export const testId = 'Skeleton';

/**
 * A placeholder block for content that has not arrived.
 *
 * Shown instead of an empty space so a screen waiting on a quote reads as
 * loading rather than broken. Hidden from assistive tech: there is nothing
 * here to announce, and the control it stands in for announces itself once it
 * arrives.
 */
export function Skeleton({ className = 'h-4 w-full' }: IProps): JSX.Element {
    return (
        <span
            aria-hidden='true'
            data-testid={testId}
            className={`block rounded-md bg-optionTrack motion-safe:animate-pulse ${className}`}
        />
    );
}
